import { STICKERS_BY_ID } from "@/data/stickers";

export default function PageSVG({
  page,
  fills = {},
  strokes = [],
  placed = [],
  interactive = false,
  svgRef,
  children,
  ...rest
}) {
  return (
    <svg
      ref={svgRef}
      viewBox="0 0 400 500"
      xmlns="http://www.w3.org/2000/svg"
      className="block h-auto w-full select-none"
      {...rest}
    >
      {page.art.map((p, i) =>
        p.line ? (
          <path
            key={i}
            d={p.d}
            fill="none"
            stroke="#241531"
            strokeWidth={p.w || 3}
            strokeLinecap="round"
            strokeLinejoin="round"
            pointerEvents="none"
          />
        ) : (
          <path
            key={i}
            data-i={i}
            d={p.d}
            fill={fills[i] || "#FFFDF8"}
            stroke="#241531"
            strokeWidth={3.4}
            strokeLinejoin="round"
            style={interactive ? { cursor: "pointer" } : undefined}
          />
        )
      )}
      {strokes.map((st) => (
        <path
          key={st.id}
          d={pointsToPath(st.points)}
          stroke={st.color}
          strokeWidth={st.size}
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          pointerEvents="none"
        />
      ))}
      {placed.map((st) => (
        <g
          key={st.id}
          transform={`translate(${st.x - 24 * st.s} ${st.y - 24 * st.s}) scale(${st.s})`}
          style={interactive ? { cursor: "pointer" } : undefined}
        >
          {STICKERS_BY_ID[st.stickerId].art}
        </g>
      ))}
      {children}
    </svg>
  );
}

export function pointsToPath(points) {
  if (!points.length) return "";
  return `M ${points.map((p) => `${p.x.toFixed(1)} ${p.y.toFixed(1)}`).join(" L ")}`;
}
